var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
let GoogleAd = class GoogleAd extends React.PureComponent {
    static defaultProps = {
        style: {}
    };
    insRef = React.createRef();
    render() {
        const { app, slotId, style, customAd, className } = this.props;
        if (app.appInfo.isMobileAppWebView)
            return null;
        if (app.appInfo.isPremiumApp)
            return null;
        const custom = customAd || {};
        //   <CloseAd app={app} />
        return (React.createElement(React.Fragment, null,
            React.createElement("ins", { ref: this.insRef, className: "adsbygoogle", style: { display: 'inline-block', ...style }, "data-ad-client": "ca-pub-2730314319476104", "data-ad-slot": slotId, ...custom })));
    }
    componentDidMount() {
        this.props.app.appAds.fillGoogleAds();
    }
};
GoogleAd = __decorate([
    observer
], GoogleAd);
export { GoogleAd };
